import Storage from './Storage';

/**
 * Store CartLocation
 * 
 */
class CartLocation extends Storage {
    storeName = 'cart_location_';
    hasOldKey = true;

    /**
     * CartLocation constructor
     * 
     * @param {string} id location id
     */
    constructor(id) {
        super();
        this.id = id;
        this.setKey();
    }

    /**
     * @override
     * 
     * Format data for store
     * 
     * @param {*} data data to store
     * @returns 
     */
     formatSetData(data) {
        let returnData = JSON.stringify(data);
        return returnData;
    }


    /**
     * @override
     * 
     * Format data for store
     * 
     * @param {*} data data to store
     * @returns 
     */
     formatSetDataOld(data) {
        data = (data && data.data) ? data.data : data;
        let returnData = JSON.stringify(data);
        return returnData;
    }

}

export default CartLocation;